import SmtpContainer from "./SmtpContainer";
import SmtpStore from "./SmtpStore";

export default SmtpStore(SmtpContainer);